import { PrivacyPolicy, TermsOfUse } from '@strata/react-page-templates';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

import { AuthCallback } from 'components/auth/AuthCallback';
import { LoggedOut } from 'components/auth/LoggedOut';
import { RequireAuth } from 'components/auth/RequireAuth';
import { Home } from 'components/home/Home';
import { UpdatesHistoryScreen } from 'components/home/UpdatesHistoryScreen';
import { ArchivedIntakeCasesGrid } from 'components/intakeCases/ArchivedIntakeCasesGrid';
import { IntakeCaseDetails } from 'components/intakeCases/IntakeCaseDetails';
import { IntakeCaseGrid } from 'components/intakeCases/IntakeCaseGrid';
import { MonitoringIntakeCasesGrid } from 'components/intakeCases/MonitoringIntakeCasesGrid';
import { IntakeForm } from 'components/intakeForm/IntakeForm';
import { ActiveIntakeSourcesGrid } from 'components/intakeSources/ActiveIntakeSourcesGrid';
import { ArchivedIntakeSourcesGrid } from 'components/intakeSources/ArchivedIntakeSourcesGrid';
import { AppRoutes } from 'services/routes';

export const App = () => (
    <BrowserRouter basename="/">
        <Routes>
            <Route path={AppRoutes.callback} element={<AuthCallback />} />
            <Route path={AppRoutes.loggedOut} element={<LoggedOut />} />
            <Route element={<RequireAuth />}>
                <Route path={AppRoutes.home} element={<Home />} />
                <Route path={AppRoutes.intakeForm} element={<IntakeForm />} />
                <Route path={AppRoutes.activeIntakeSources} element={<ActiveIntakeSourcesGrid />} />
                <Route
                    path={AppRoutes.archivedIntakeSources}
                    element={<ArchivedIntakeSourcesGrid />}
                />
                <Route path={AppRoutes.activeIntakeCases} element={<IntakeCaseGrid />} />
                <Route
                    path={AppRoutes.monitoringIntakeCases}
                    element={<MonitoringIntakeCasesGrid />}
                />
                <Route path={AppRoutes.archivedIntakeCases} element={<ArchivedIntakeCasesGrid />} />
                <Route path={AppRoutes.intakeCaseDetails()} element={<IntakeCaseDetails />} />
                <Route path={AppRoutes.termsOfUse} element={<TermsOfUse />} />
                <Route path={AppRoutes.privacyPolicy} element={<PrivacyPolicy />} />
                <Route path={AppRoutes.updatesHistory} element={<UpdatesHistoryScreen />} />
            </Route>
            <Route path="*" element={<Navigate replace to={AppRoutes.home} />} />
        </Routes>
    </BrowserRouter>
);
